/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iletisim_S7_R3_LabelInputs */

const tr_iletisim_s7_r3_label = /** @type {(inputs: Iletisim_S7_R3_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e-Tüketici Bilgi Sistemi`)
};

const en_iletisim_s7_r3_label = /** @type {(inputs: Iletisim_S7_R3_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e-Tüketici Bilgi Sistemi (e-consumer information system)`)
};

const de_iletisim_s7_r3_label = /** @type {(inputs: Iletisim_S7_R3_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e-Tüketici Bilgi Sistemi (Verbraucher-Informationssystem)`)
};

const ru_iletisim_s7_r3_label = /** @type {(inputs: Iletisim_S7_R3_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e-Tüketici Bilgi Sistemi (информационная система для потребителей)`)
};

/**
* | output |
* | --- |
* | "e-Tüketici Bilgi Sistemi (e-consumer information system)" |
*
* @param {Iletisim_S7_R3_LabelInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iletisim_s7_r3_label = /** @type {((inputs?: Iletisim_S7_R3_LabelInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iletisim_S7_R3_LabelInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iletisim_s7_r3_label(inputs)
	if (locale === "de") return de_iletisim_s7_r3_label(inputs)
	if (locale === "ru") return ru_iletisim_s7_r3_label(inputs)
	return tr_iletisim_s7_r3_label(inputs)
});